export default [
  {
    path: 'accounting/cash',
    name: 'report-accounting-cash',
    component: () => import('./List.vue'),
    meta: {
      title: 'Báo cáo thu chi theo cửa hàng - ClickBuy',
    },
  },
]
